import { Accordion, Div, Text, Title } from "view/lib/components";
import Button from "view/lib/components/button";

interface Props {
  readonly data: Record<string, any>;
  readonly goToPortfolio: () => void;
}

const About = ({ data, goToPortfolio }: Props) =>
  <Div style={styles.container}>
    <Title title="About" />
    <Div style={styles.section}>
      <Text style={styles.biographyTitle}>// Biography</Text>
      <Text>{data.biography}</Text>
    </Div>
    <Text>Please go to the <Button style={styles.portfolioButton} onClick={goToPortfolio}>Portfolio</Button> page for information related to work and projects</Text>
    <Accordion
      title={"Education"}
      item={educationItem(data.education)} />
    <Accordion
      title={"Languages"}
      item={languagesItem(data.languages)} />
    <Accordion
      title={"Honors & Awards"}
      item={honorsItem(data.honors)} />
    <Accordion
      title={"Activities"}
      item={activitiesItem(data.activities)} />
  </Div>;

const activitiesItem = (activities: ReadonlyArray<Record<string, any>>) =>
  <Div style={styles.section}>
    <table style={styles.table}>
      <thead>
        <tr>
        {Object.keys(activities[0]).map((key) =>
          <th key={key} style={styles.td}>
            <Text>{key.toUpperCase()}</Text>
          </th>
        )}
        </tr>
      </thead>
      <tbody>
        {
          activities.map((column: Record<string, string>) =>
            <tr key={column.activity}>
              <td style={styles.td}><Text>{column.activity}</Text></td>
              <td style={styles.td}><Text>{column.institution}</Text></td>
              <td style={styles.td}><Text>{column.year}</Text></td>
            </tr>
        )}
      </tbody>
    </table>
  </Div>

const honorsItem = (honors: ReadonlyArray<Record<string, any>>) =>
  <Div style={styles.section}>
    <table style={styles.table}>
      <thead>
        <tr>
        {Object.keys(honors[0]).map((key) =>
          <th key={key} style={styles.td}>
            <Text>{key.toUpperCase()}</Text>
          </th>
        )}
        </tr>
      </thead>
      <tbody>
        {
          honors.map((column: Record<string, string>) =>
            <tr key={column.award}>
              <td style={styles.td}><Text>{column.award}</Text></td>
              <td style={styles.td}><Text>{column.year}</Text></td>
            </tr>
        )}
      </tbody>
    </table>
  </Div>

const educationItem = (education: ReadonlyArray<Record<string, any>>) =>
  <Div style={styles.section}>
    <table style={styles.table}>
      <thead>
        <tr>
        {Object.keys(education[0]).map((key) =>
          <th key={key} style={styles.td}>
            <Text>{key.toUpperCase()}</Text>
          </th>
        )}
        </tr>
      </thead>
      <tbody>
        {
          education.map((column: Record<string, string>) =>
            <tr key={column.title}>
              <td style={styles.td}><Text>{column.title}</Text></td>
              <td style={styles.td}><Text>{column.institution}</Text></td>
              <td style={styles.td}><Text>{column.duration}</Text></td>
            </tr>
        )}
      </tbody>
    </table>
  </Div>

const languagesItem = (languages: Record<string, any>) =>
  <Div style={styles.section}>
    <table style={styles.table}>
      <thead>
        <tr>
          {Object.keys(languages[0]).map((key) =>
            <th key={key} style={styles.td}>
              <Text>{key.toUpperCase()}</Text>
            </th>
          )}
        </tr>
      </thead>
      <tbody>
        {
          languages.map((column: Record<string, string>) =>
            <tr key={column.language}>
              <td style={styles.td}><Text>{column.language}</Text></td>
              <td style={styles.td} colSpan={column.institution ? 1 : 2}><Text>{column.proficiency}</Text></td>
              {column.institution && <td style={styles.td}><Text>{column.institution}</Text></td>}
            </tr>
        )}
      </tbody>
    </table>
  </Div>

const styles = {
  container: {
    padding: "3%"
  },
  title: {
    fontSize: "xx-large"
  },
  portfolioButton: {
    padding: "0",
    textTransform: "none",
    minWidth: "0"
  },
  biographyTitle: {
    fontSize: "x-large"
  },
  section: {
    margin: "2% 0%"
  },
  columnName: {
    fontSize: "large"
  },
  table: {
    width: "100%",
    border: "1px solid black"
  },
  td: {
    padding: "1%",
    border: "1px solid black"
  }
}

export default About;